!function($, window, document) {
    const $win = $(window), $html = $("html"), $adminbar = $("#wpadminbar"), $header = $(".header"), $footer = $(".footer"), $body = $("body");
    function isContentLargerThanPopup($popup) {
        if (0 === $popup.length) return !1;
        const parentHeight = $popup.outerHeight();
        return $popup.children().map((function() {
            return $(this).outerHeight();
        })).get().reduce(((sum, height) => sum + height), 0) > parentHeight;
    }
    function getAdminBarHeight() {
        return $adminbar.length > 0 ? $adminbar.outerHeight() : 0;
    }
    function setCSSVariable(name, value, unit = "", $element = $body) {
        value && $element.css(`--${name}`, `${value}${unit}`);
    }
    function isTouchDevice() {
        return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }
    function scrollToTarget($target) {
        $target.length < 1 || $body.add($html).stop().animate({
            scrollTop: $target.offset().top - $header.outerHeight() - getAdminBarHeight()
        }, 600);
    }
    $.event.special.widthResize = {
        setup: function() {
            const $this = $(this);
            $this.data("currentWidth", $this.width()), $this.on("resize.widthResize", (function() {
                const newWidth = $this.width();
                newWidth !== $this.data("currentWidth") && $this.data("currentWidth", newWidth).trigger("widthResize");
            }));
        },
        teardown: function() {
            $(this).off("resize.widthResize");
        }
    }, setCSSVariable("dvh", .01 * window.innerHeight, "px"), setCSSVariable("current-dvh", .01 * window.innerHeight, "px"), 
    setCSSVariable("header-height", $header.outerHeight(), "px"), setCSSVariable("footer-height", $footer.outerHeight(), "px"), 
    setCSSVariable("adminbar-height", getAdminBarHeight(), "px"), setCSSVariable("scrollbar-width", function getScrollbarWidth() {
        const outer = document.createElement("div");
        outer.style.visibility = "hidden", outer.style.overflow = "scroll", outer.style.msOverflowStyle = "scrollbar", 
        document.body.appendChild(outer);
        const inner = document.createElement("div");
        outer.appendChild(inner);
        const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
        return outer.parentNode.removeChild(outer), scrollbarWidth;
    }(), "px"), $body.toggleClass("is-touch-device", isTouchDevice()), $win.on("resize scroll", (function() {
        setCSSVariable("current-dvh", .01 * window.innerHeight, "px"), setCSSVariable("header-height", $(".header").outerHeight(), "px"), 
        setCSSVariable("footer-height", $footer.outerHeight(), "px"), setCSSVariable("adminbar-height", getAdminBarHeight(), "px"), 
        $body.toggleClass("is-touch-device", isTouchDevice());
    })), $win.on("widthResize", (function() {
        setCSSVariable("dvh", .01 * window.innerHeight, "px");
    })), $(".js-scroll-to").on("click", (function(e) {
        e.preventDefault();
        const $this = $(this), targetSelector = $this.attr("href");
        scrollToTarget("#" != targetSelector ? $(targetSelector) : $this.closest("section").next());
    })), $win.on("scroll resize", (function() {
        const scrollTop = $win.scrollTop();
        $header.toggleClass("header--above", scrollTop > $header.outerHeight()), $header.toggleClass("header--fixed", scrollTop > 3 * $header.outerHeight()), 
        $header.toggleClass("header--visible", scrollTop > 5 * $header.outerHeight());
    }));
    const ajaxExample = GLightbox({
        selector: null,
        openEffect: "fade",
        closeEffect: "fade",
        touchNavigation: !1,
        touchFollowAxis: !1,
        keyboardNavigation: !1,
        closeButton: !0,
        draggable: !1
    });
    ajaxExample.on("open", (() => {
        $body.addClass("glightbox-loaded"), $(".ginlined-content").each((function() {
            const $this = $(this);
            $this.toggleClass("is-scrollable", isContentLargerThanPopup($this)), $this.data("lastScrollTop", 0), 
            $win.on("resize", (function() {
                $this.toggleClass("is-scrollable", isContentLargerThanPopup($this));
            })), $this.on("scroll", (function() {
                if (isContentLargerThanPopup($this)) {
                    const scrollTop = $this.scrollTop(), isScrollUp = scrollTop < $this.data("lastScrollTop");
                    $this.toggleClass("is-scrolled-up", isScrollUp), $this.toggleClass("is-scrolled", scrollTop > 0), 
                    $this.data("lastScrollTop", scrollTop);
                }
            }));
        }));
    })), ajaxExample.on("close", (() => {
        $body.removeClass("glightbox-loaded");
    })), $(document).on("click", ".gbtn.gclose", (function() {
        ajaxExample.close();
    })), $(".js-popup").on("click", (function(e) {
        e.preventDefault();
        const popupUrl = $(this).attr("href"), postId = $(this).data("id");
        $.ajax({
            url: popupUrl,
            type: "GET",
            data: {
                postId: postId
            },
            success: response => {
                ajaxExample.setElements([ {
                    content: response
                } ]), ajaxExample.open();
            },
            error: (xhr, status, error) => {
                console.error("AJAX Error: ", error);
            }
        });
    }));
    const intersectionObserver = new IntersectionObserver((entries => {
        entries.forEach((entry => {
            entry.isIntersecting && $(entry.target).addClass("is-visible");
        }));
    }), {
        threshold: 0,
        rootMargin: "0px 0px"
    });
    $("[data-fade-up]").each((function(_index, el) {
        intersectionObserver.observe(el);
    })), $(".js-nav-btn").on("click", (function(e) {
        e.preventDefault(), $body.toggleClass("nav-open");
    })), $(document).on("click", ".js-filter-assets", (function(e) {
        e.preventDefault();
        let category = $(this).data("cat");
        $(this).parent().addClass("is-active"), $(this).parent().siblings().removeClass("is-active"), 
        $.ajax({
            url: window.location.href,
            data: {
                category: category
            },
            success: function(response) {
                $(".listing--articles-medium .listing__content .grid").html($(response).find(".listing--articles-medium .listing__content .grid").html()), 
                $("[data-fade-up]").each((function(_index, el) {
                    intersectionObserver.observe(el);
                }));
            }
        });
    })), $(document).on("click", ".js-load-more-assets", (function(e) {
        e.preventDefault();
        let page = $(this).data("page");
        $.ajax({
            url: window.location.herf,
            data: {
                page: page
            },
            success: function(response) {
                $(".listing--articles-small .listing__content .grid").append($(response).find(".listing--articles-small .listing__content .grid").html()), 
                $(response).find(".listing__actions").length ? ($(".listing__actions").html($(response).find(".listing__actions").html()), 
                $(".js-load-more-assets").data("page", page + 1)) : $(".listing__actions").remove(), 
                $("[data-fade-up]").each((function(_index, el) {
                    intersectionObserver.observe(el);
                }));
            }
        });
    })), $(document).on("click", ".js-pagination", (function(e) {
        e.preventDefault(), history.pushState(null, "", $(this).attr("href")), $(".section-assets").addClass("loading"), 
        $.ajax({
            url: $(this).attr("href"),
            success: function(response) {
                $(".section-assets").html($(response).find(".section-assets").html()), $(".section-assets").removeClass("loading"), 
                $("[data-fade-up]").each((function(_index, el) {
                    intersectionObserver.observe(el);
                }));
            }
        });
    }));
}(jQuery, window, document);